import React, { useEffect, useState, useRef } from "react"
import { useParams, withRouter } from "react-router-dom"
import { connect, useSelector, useDispatch } from "react-redux"
import {
    Row,
    Col,
    UncontrolledTooltip,
    Button,
    Card,
    CardBody,
    Table,
    Container,
    Input,
    Label
} from "reactstrap"
//Import Styles
import Select from "react-select"
import "./styles.scss"
import PropTypes from "prop-types"
//import api from "helpers/Api"
import { isEmpty } from "lodash"
import Modal from "react-bootstrap/Modal"
import Collapse from "react-bootstrap/Collapse"
import SimpleReactValidator from "simple-react-validator"
import moment from "moment"
import { toast } from "react-toastify"
import clientAction from "../../store/Y2xpZW50/actions"
import * as copyDataAction from "../../store/Y29weURhdGE/actions"

const CopyDataTeamScheduling = (props) => {
    const { dispatch, modeMenu, clientId, clientProfile } = props
    const { id } = useParams()
    const specificDispatch = useDispatch()

    const clientData = clientProfile && !isEmpty(clientProfile) && clientProfile.leadDetails &&
        clientProfile.leadDetails.length > 0 ? clientProfile.leadDetails : ""
    //filter leadId
    const clientDataByLeadId = !isEmpty(clientData) && clientData.length > 0 ?
        clientData.filter((m) => m.leadId === id) : []

    const commitDetails = !isEmpty(clientDataByLeadId) ? clientDataByLeadId[0] : []
    const isNasCommit = !isEmpty(commitDetails) && commitDetails.nasProcessStatusName != undefined &&
        !isEmpty(commitDetails.nasProcessStatusName) && !isEmpty(commitDetails.nasProcessStatus) ?
        commitDetails.nasProcessStatusName : ""

    console.log(isNasCommit, "clientData")
    console.log(commitDetails, "commitDetails")

    useEffect(() => {
        specificDispatch(copyDataAction.loadDataScheduling({ leadId: id }))
        dispatch(copyDataAction.loadNasLinkList({ leadId: id }))
        dispatch(copyDataAction.loadServiceLevel({ status: "both" }))
    }, [])

    const update = useSelector((state) => state.copyData)
    const salesUpdate = useSelector((specificstate) => specificstate.sales)

    const { employee_list = [] } = salesUpdate

    const {
        data_scheduling_details = [],
        shooter_history = [],
        nas_link_details = [],
        serviceLevel_details = []
    } = update
    const [collapseData, setCollapseData] = useState([])

    useEffect(() => {

        const delay = setTimeout(() => {
            setCollapseData(data_scheduling_details)

        }, 500)

        return () => clearTimeout(delay)
    }, [data_scheduling_details])

    console.log(collapseData, "collap")
    //State section
    // const [tableFilterOpt, setTableFilterOpt] = useState([])
    const [historyModal, setHistoryModal] = useState(false)
    const handleHistoryModal = () => setHistoryModal(false)
    // const [uploadInput, setUploadInput] = useState([])
    // const [uploadTicketInput, setUploadTicketInput] = useState([])
    const simpleValidator = useRef(new SimpleReactValidator())
    const [, forceUpdate] = useState()
    const simpleUploadValidator = useRef(new SimpleReactValidator())
    const [, forceUpload] = useState()
    const [open, setOpen] = useState(false)

    //Final Commit
    //const [eventId, setEventId] = useState("")
    const [eventCommit, setEventCommit] = useState(false)
    const [finalCommitModal, setFinalCommitModal] = useState(false)
    const [commitHistoryModal, setCommitHistoryModal] = useState(false)
    const handleCommitHistoryModal = () => setCommitHistoryModal(false)

    const [collapseDetails, setCollapseDetails] = useState("")

    const employeeList =
        !isEmpty(employee_list) && employee_list.length > 0
            ? employee_list.map((employee) => {
                return {
                    _id: employee._id,
                    empCode: employee.empCode,
                    name: employee.name,
                    companyId: employee.companyId,
                    roleId: employee.roleId,
                    departmentId: employee.departmentId,
                    departmentName: employee.departmentName,
                    designationId: employee.designationId,
                    designationName: employee.designationName,
                }
            })
            : []
    const employeeListData = !isEmpty(employeeList)
        ? employeeList.filter((data) => data !== undefined)
        : []
    const createOptions = (array) => {
        const options = []
        !isEmpty(array) &&
            array.forEach((element) => {
                const labelEmployee = element.empCode.concat(" - ", element.name)
                // [...element.empCode,...element.name].join('')

                let obj = {}
                obj.value = element._id
                obj.empCode = element.empCode
                obj.label = labelEmployee
                obj.companyId = element.companyId
                obj.roleId = element.roleId
                obj.departmentId = element.departmentId
                obj.departmentName = element.departmentName
                obj.designationId = element.designationId
                obj.designationName = element.designationName
                options.push(obj)
            })
        return options
    }

    const employeeOptions = createOptions(employeeListData)
    console.log(employeeOptions, "employeeOptions")
    console.log(employeeListData, "employeeListData")
    console.log(employeeList, "employeeList")



    //   const currentMonth = moment().format("MMMM")
    const month = moment().format("MM")
    //   const year = moment().format("YYYY")

    //Event Time

    const eventStartTimeData = moment(collapseDetails.startTime, [
        "HH.mm",
    ]).format("hh:mm a")
    const eventEndTimeData = moment(collapseDetails.endTime, ["HH.mm"]).format(
        "hh:mm a"
    )
    const crewAssemblyTimeData = !isEmpty(collapseDetails.crewAssemblyTime)
        ? moment(collapseDetails.crewAssemblyTime, ["HH.mm"]).format("hh:mm a")
        : "--"

    console.log(
        eventStartTimeData,
        eventEndTimeData,
        crewAssemblyTimeData,
        "crewAssemblyTimeData"
    )

    console.log(month, "month")

    const [editModal, setEditModal] = useState(false)
    //Collapsable data
    // const collapseData =
    //     !isEmpty(data_scheduling_details) && data_scheduling_details.length > 0
    //         ? data_scheduling_details
    //         : []

    console.log(data_scheduling_details, "collpaseDetails")
    // const [commitHistoryDetails, setCommitHistoryDetails] = useState("")

    const [serviceDetailsData, setServiceDetailsData] = useState([
        {
            teamScheduleIdServideId: "",
            serviceId: "",
            serviceName: "",
            teamType: "",
            serviceLevelStatusName: "",
            serviceLevelStatusId: "",
            fileCount: "",
            size: "",
            teamEmployeeShooterId: "",
            teamEmployeeShooterName: "",
            freelancerId: "",
            freelancerName: "",
            remarks: ""

        },
    ])
    const clearServiceData = () => {
        setServiceDetailsData(prevState =>
            prevState.map(service => ({
                ...service,
                serviceLevelStatusName: "",
                serviceLevelStatusId: "",
                fileCount: "",
                size: "",
                paymentStatus: "",
                paymentStatusId: "",
                remarks: ""
            }))
        )
    }
    // const clearServiceData = () => {
    //     setServiceDetailsData([...serviceDetailsData,
    //     {

    //         serviceLevelStatusName: "",
    //         serviceLevelStatusId: "",
    //         fileCount: "",
    //         size: "",
    //         paymentStatus: "",
    //         paymentStatusId: "",
    //         remarks: ""

    //     },
    //     ])
    // }

    const [renderPage, setRenderPage] = useState(false)
    // const [subFreelancerListData, setSubFreelancerListData] = useState("")
    //const [removeService, setRemoveService] = useState(false)
    // const [shooterPosition, setShooterPosition] = useState("")




    const modalChange = async (e, index, name) => {
        var serviceList = serviceDetailsData

        if (name == "serviceLevelStatusId") {
            serviceList[index]["serviceLevelStatusId"] = e.value
            serviceList[index]["serviceLevelStatusName"] = e.label
            setServiceDetailsData(serviceList)
        }
        if (name === "fileCount" || name === "size" || name === "remarks") {
            serviceList[index][name] = e.target.value
        }

        setRenderPage(!renderPage)
    }

    const eventDate = moment(collapseDetails.eventDate).format("DD-MM-YYYY")
    console.log(eventDate, "eventDate")

    //   const uploadTicketChange = async (e) => {
    //     if (e.target.files) {
    //       console.log("qqqq", e.target.files)
    //       setUploadTicketInput(e.target.files)
    //       var file = e.target.files
    //       var fileArrayDetails = Array.from(file)
    //       var teamUploadValue = uploadTicketInput

    //       for (let x in fileArrayDetails) {
    //         const formData = new FormData()
    //         formData.append("file", fileArrayDetails[x])
    //         api
    //           .post("/image_upload", formData)
    //           .then(async (res) => {
    //             if (res && res.data && res.data.data) {
    //               teamUploadValue.push(res.data.data)
    //               await setUploadTicketInput(teamUploadValue)
    //             } else {
    //               alert("Upload Failed!. Please try again")
    //             }
    //           })
    //           .catch(() => {
    //             alert("Unable to Upload file")
    //           })
    //       }
    //     }
    //   }
    // console.log(uploadTicketInput, "UploadTicketInput")
    //console.log(tableFilterOpt, "tableFilterOpt")
    // console.log(subFreelancerListData, "subFreelancerListData")

    // const [finalCommitValidation, setFinalCommitValidation] = useState(false)
    // const finalCommit = () => {
    //     var dataCommit = {
    //         leadId: id,
    //         eventId: tableFilterOpt.map((data) => data.value),
    //     }

    //     dispatch(copyDataAction.dataFinalCommit(dataCommit))
    //     setTimeout(() => {
    //         dispatch(copyDataAction.loadDataScheduling({ leadId: id }))
    //         toast.success("Records Committed Successfully", {
    //             position: toast.POSITION.TOP_RIGHT,
    //         })
    //         setFinalCommitModal(false)
    //     }, 1500)
    // }

    const addTeamEvents = (data) => {
        const serviceDetails = !isEmpty(serviceDetailsData)
            ? serviceDetailsData.map((item) => {
                const commonProps = {
                    teamScheduleServiceId: item.teamScheduleIdServideId,
                    serviceId: item.serviceId,
                    serviceName: item.serviceName,
                    type: item.teamType,
                    teamShooterId: item.teamEmployeeShooterId,
                    teamShooterName: item.teamEmployeeShooterName,
                }

                const freelancerCommonProps = {
                    teamScheduleServiceId: item.teamScheduleIdServideId,
                    serviceId: item.serviceId,
                    serviceName: item.serviceName,
                    type: item.teamType,
                    freelancerId: item.freelancerId,
                    freelancerName: item.freelancerName,
                }

                if (item.teamType === "InHouse") {
                    const inHouseProps = {
                        serviceLevelStatusId: item.serviceLevelStatusId,
                        fileCount: parseInt(item.fileCount),
                        size: item.size,
                        remarks: item.remarks
                    }

                    if (isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...commonProps }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...commonProps, remarks: item.remarks }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && !isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...commonProps, size: item.size }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && !isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...commonProps, size: item.size, remarks: item.remarks }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...commonProps, fileCount: parseInt(item.fileCount) }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...commonProps, fileCount: parseInt(item.fileCount), remarks: item.remarks }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...commonProps, serviceLevelStatusId: item.serviceLevelStatusId }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...commonProps, serviceLevelStatusId: item.serviceLevelStatusId, remarks: item.remarks }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...commonProps, serviceLevelStatusId: item.serviceLevelStatusId, fileCount: parseInt(item.fileCount) }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...commonProps, serviceLevelStatusId: item.serviceLevelStatusId, fileCount: parseInt(item.fileCount), remarks: item.remarks }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && !isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...commonProps, serviceLevelStatusId: item.serviceLevelStatusId, size: item.size }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && !isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...commonProps, serviceLevelStatusId: item.serviceLevelStatusId, size: item.size, remarks: item.remarks }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && !isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...commonProps, serviceLevelStatusId: item.serviceLevelStatusId, fileCount: parseInt(item.fileCount), size: item.size }
                    } else {
                        return { ...commonProps, ...inHouseProps }
                    }
                } else {
                    const freelancerProps = {
                        serviceLevelStatusId: item.serviceLevelStatusId,
                        fileCount: parseInt(item.fileCount),
                        size: item.size,
                        remarks: item.remarks
                    }

                    if (isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, remarks: item.remarks }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && !isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, size: item.size }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && !isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, size: item.size, remarks: item.remarks }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, fileCount: parseInt(item.fileCount) }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, fileCount: parseInt(item.fileCount), remarks: item.remarks }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, serviceLevelStatusId: item.serviceLevelStatusId }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, serviceLevelStatusId: item.serviceLevelStatusId, remarks: item.remarks }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, serviceLevelStatusId: item.serviceLevelStatusId, fileCount: parseInt(item.fileCount) }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, serviceLevelStatusId: item.serviceLevelStatusId, fileCount: parseInt(item.fileCount), remarks: item.remarks }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && !isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, serviceLevelStatusId: item.serviceLevelStatusId, size: item.size }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && !isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, serviceLevelStatusId: item.serviceLevelStatusId, size: item.size, remarks: item.remarks }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && !isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, serviceLevelStatusId: item.serviceLevelStatusId, fileCount: parseInt(item.fileCount), size: item.size }
                    } else {
                        return { ...freelancerCommonProps, ...freelancerProps }
                    }
                }

            }) : []

        var teamScheduling = {
            leadId: id,
            clientId: clientId,
            teamScheduleId: data.teamScheduleId,
            leadEventId: data.leadEventId,
            eventId: data.event,
            eventName: data.eventName,
            eventDate: moment(data.eventDate).format("YYYY-MM-DD"),
            serviceDetails: serviceDetails,
        }

        console.log(teamScheduling, "teamScheduling")
        dispatch(copyDataAction.addDataScheduling(teamScheduling))
        setTimeout(() => {
            setOpen(false)
            toast.success("Records Added Successfully", {
                position: toast.POSITION.TOP_RIGHT,
            })
            clearServiceData()
            // dispatch(copyDataAction.loadEventTeamSchedling(eventScheduling))
            dispatch(copyDataAction.loadDataScheduling({ leadId: id }))
        }, 2000)
    }
    //    {eventServiceModal && open === false ? (

    //State handle
    const [leadEventId, setLeadEventId] = useState("")
    const [collapseServiceDetails, setCollapseServiceDetails] = useState("")
    const [eventServiceModal, setEventServiceModal] = useState(false)

    const [serviceOpen, setServiceOpen] = useState(false)
    // const [editTeamScheduleId, setEditTeamScheduleId] = useState(false)
    const [pageLoad, setPageLoad] = useState(false)
    const [serviceDetailOpenDataSet, setServiceDetailOpenDataSet] =
        useState(false)


    console.log(collapseDetails, "collapseDetails")
    // console.log(editTeamScheduleDetails, "editTeamScheduleDetails")

    //Initial collapse service details
    const collapseService =
        !isEmpty(collapseServiceDetails) && collapseServiceDetails.serviceDetails
            ? collapseServiceDetails.serviceDetails.map((data) => {
                if (collapseServiceDetails.leadEventId === leadEventId) {

                    return {
                        teamScheduleIdServideId: data.teamScheduleIdServideId,
                        serviceId: data.serviceId,
                        serviceName: data.serviceName,
                        teamType: data.teamType,
                        serviceLevelStatusName: "",
                        serviceLevelStatusId: "",
                        fileCount: "",
                        size: "",
                        teamEmployeeShooterId: data.teamEmployeeShooterId,
                        teamEmployeeShooterName: data.teamEmployeeShooterName,
                        freelancerId: data.freelanceMainShooterId,
                        freelancerName: data.freelanceMainShooterName,
                        paymentStatus:
                            data.paymentStatus === "free" ? "FREE" : "PAID",
                        paymentStatusId:
                            data.paymentStatus === "free" ? "free" : "paid",


                    }
                }
            })
            : []
    useEffect(() => {
        if (
            serviceOpen &&
            collapseService &&
            collapseService.length > 0 &&
            !serviceDetailOpenDataSet
        ) {
            setServiceDetailsData(collapseService)
            setServiceDetailOpenDataSet(true)
        }
    }, [collapseService])

    console.log(collapseService, "collapseService")




    console.log(collapseService, "collapseService")


    //Edit Team Events
    const editTeamEvents = (event) => {
        setLeadEventId(event.leadEventId)
        setEventServiceModal(true)

        console.log(event, "event edit")
    }


    const editDataCopyScheduling = (data) => {


        var dataCopyDetailsEdit = data && data.serviceDetails
        console.log(dataCopyDetailsEdit, "my array data")
        const dataCopyDetailsEditUpdated = !isEmpty(dataCopyDetailsEdit)
            ? dataCopyDetailsEdit.map((data) => {
                return {
                    teamScheduleIdServideId: data.teamScheduleIdServideId,
                    serviceId: data.serviceId,
                    serviceName: data.serviceName,
                    teamType: data.teamType,
                    serviceLevelStatusName: data.serviceLevelStatusName,
                    serviceLevelStatusId: data.serviceLevelStatusId,
                    fileCount: data.fileCount,
                    size: data.size,
                    teamEmployeeShooterId: data.teamEmployeeShooterId,
                    teamEmployeeShooterName: data.teamEmployeeShooterName,
                    freelancerId: data.freelanceMainShooterId,
                    freelancerName: data.freelanceMainShooterName,
                    paymentStatus: data.paymentStatus,
                    paymentStatusId: data.paymentStatusId,
                    remarks: data.remarks,
                    connectingId: data.connectingId

                }
            })
            : []

        setServiceDetailsData(dataCopyDetailsEditUpdated)
        console.log(dataCopyDetailsEditUpdated, "edited")

    }
    // useEffect(() => {
    //     if (editModal === true) {
    //         api
    //             .post("get_data_copy_scheduling", eventScheduling)
    //             .then((res) => {
    //                 const editTeamScheduling =
    //                     !isEmpty(res.data.data) && res.data.data && res.data.data.length > 0
    //                         ? res.data.data.map((data) => {
    //                             if (data.eventId === leadEventId) {
    //                                 return data
    //                             }
    //                         })
    //                         : []
    //                 const editTeamSchedulingList = !isEmpty(editTeamScheduling)
    //                     ? editTeamScheduling.filter((data) => data !== undefined)
    //                     : []

    //                 // setServiceDetailsData(eventService)
    //                 console.log(editTeamSchedulingList, "editTeamSchedulingList")
    //                 // setTimeout(() => {
    //                 setEditTeamScheduleDetails(editTeamSchedulingList)
    //                 // const ticket =
    //                 //     isEmpty(editTeamSchedulingList) &&
    //                 //         editTeamSchedulingList &&
    //                 //         editTeamSchedulingList.length == 0
    //                 //         ? 0
    //                 //         : editTeamSchedulingList[0].groupTicket
    //                 // const grouptTicket = !isEmpty(ticket) ? ticket : 0
    //                 setDataSchedulingDetails(editTeamSchedulingList[0])
    //                 const historyDetails =
    //                     !isEmpty(editTeamSchedulingList) &&
    //                         editTeamSchedulingList.length > 0
    //                         ? editTeamSchedulingList[0]
    //                         : []
    //                 console.log(historyDetails, "historyDetails")
    //                 // console.log(ticket, "ticket")

    //                 setCommitHistoryDetails(historyDetails.commitHistory)

    //                 const serviceDetailsSet =
    //                     !isEmpty(editTeamSchedulingList) &&
    //                         editTeamSchedulingList.length > 0
    //                         ? editTeamSchedulingList[0].serviceDetails.map((data, index) => {
    //                             const freelanceTypeId =
    //                                 !isEmpty(data) &&
    //                                     data.teamFreelanceShooter &&
    //                                     data.teamFreelanceShooter.length > 0
    //                                     ? data.teamFreelanceShooter[0].freelanceMainShooterId
    //                                     : ""
    //                             const freelanceTypeName =
    //                                 !isEmpty(data) &&
    //                                     data.teamFreelanceShooter &&
    //                                     data.teamFreelanceShooter.length > 0
    //                                     ? data.teamFreelanceShooter[0].freelanceMainShooterName
    //                                     : ""
    //                             const subFreelanceTypeId =
    //                                 !isEmpty(data) &&
    //                                     data.teamFreelanceShooter &&
    //                                     data.teamFreelanceShooter.length > 0
    //                                     ? data.teamFreelanceShooter[0].freelanceSubShooterId
    //                                     : ""
    //                             const subFreelanceTypeName =
    //                                 !isEmpty(data) &&
    //                                     data.teamFreelanceShooter &&
    //                                     data.teamFreelanceShooter.length > 0
    //                                     ? data.teamFreelanceShooter[0].freelanceSubShooterName
    //                                     : ""
    //                             // const subFreelanceTypeId = !isEmpty(data) && data.teamFreelanceShooter && data.teamFreelanceShooter.length > 0 ? data.teamFreelanceShooter[0].freelanceSubShooterId.subFreelancerName : ""
    //                             const freelanceAmount =
    //                                 !isEmpty(data) &&
    //                                     data.teamFreelanceShooter &&
    //                                     data.teamFreelanceShooter.length > 0
    //                                     ? data.teamFreelanceShooter[0].amount
    //                                     : ""
    //                             // const subFreelanceTypeId = !isEmpty(data) && data.teamFreelanceShooter.length > 0 ? data.teamFreelanceShooter[0].freelanceSubShooterId : []
    //                             // const freelanceAmount = !isEmpty(data) && data.teamFreelanceShooter.length > 0 ? data.teamFreelanceShooter[0].amount : []
    //                             console.log(freelanceTypeId, "freelanceTypeId")
    //                             console.log(data, "data")
    //                             return {
    //                                 _id: data._id,
    //                                 serviceNumber: data.serviceNo,
    //                                 serviceName: !isEmpty(data.serviceId)
    //                                     ? data.serviceId.serviceName
    //                                     : "",
    //                                 index: index,
    //                                 serviceNameValue: !isEmpty(data.serviceId)
    //                                     ? data.serviceId._id
    //                                     : "",
    //                                 teamType:
    //                                     data.teamType === "Freelancer" ? "Freelancer" : "InHouse",
    //                                 teamTypeId: data.teamType,
    //                                 shooterType: !isEmpty(data.teamEmployeeShooterId)
    //                                     ? `${data.teamEmployeeShooterId.empCode}-${data.teamEmployeeShooterId.name}`
    //                                     : "",
    //                                 shooterTypeId: !isEmpty(data.teamEmployeeShooterId)
    //                                     ? data.teamEmployeeShooterId._id
    //                                     : "",
    //                                 shooterPositionId: !isEmpty(data.shooterPositionId)
    //                                     ? data.shooterPositionId._id
    //                                     : "",
    //                                 shooterPosition: !isEmpty(data.shooterPositionId)
    //                                     ? data.shooterPositionId.name
    //                                     : "",
    //                                 freelancerType: freelanceTypeName,
    //                                 freelancerTypeId: freelanceTypeId,
    //                                 subFreelancerType: subFreelanceTypeName,
    //                                 subFreelancerTypeId: subFreelanceTypeId,
    //                                 freelanceAmount: freelanceAmount,
    //                                 isAlter: data.isAlter,
    //                                 paymentStatus:
    //                                     data.paymentStatus === "free" ? "FREE" : "PAID",
    //                                 paymentStatusId:
    //                                     data.paymentStatus === "free" ? "free" : "paid",
    //                                 uploadInput: data.ticket,
    //                                 vendorType:
    //                                     !isEmpty(subFreelanceTypeId) &&
    //                                         subFreelanceTypeId.length > 0
    //                                         ? "multiple"
    //                                         : "single",
    //                                 uploadInputCount: !isEmpty(data.ticket) ? 1 : 0,
    //                                 // vendorMembers: data.vendorMembers
    //                             }
    //                         })
    //                         : []
    //                 console.log(serviceDetailsSet, "serviceDetailsSet")
    //                 // setUploadTicketInput(ticket)
    //                 setServiceDetailsData(serviceDetailsSet)
    //                 // setSubFreelancerListData(subFreelanceTypeId)
    //                 // setServiceDetailDataSet(true)
    //                 // }, 500)
    //                 res.data
    //             })
    //             .catch((error) => Promise.reject(error))
    //     }
    // }, [editModal])

    // console.log(eventTeamScheduling, "eventTeamScheduling")
    console.log(leadEventId, "leadEventId")
    //  console.log(uploadInput, "upload Input")
    console.log(collapseDetails, "collapseDetails")
    // console.log(vacancyIndex, "vacancyIndex")




    const updateTeamEvents = (data) => {
        const serviceDetails = !isEmpty(serviceDetailsData)
            ? serviceDetailsData.map((item) => {

                const commonProps = {
                    teamScheduleServiceId: item.teamScheduleIdServideId,
                    serviceId: item.serviceId,
                    serviceName: item.serviceName,
                    type: item.teamType,
                    teamShooterId: item.teamEmployeeShooterId,
                    teamShooterName: item.teamEmployeeShooterName,
                    connectingId: item.connectingId
                }

                const freelancerCommonProps = {
                    teamScheduleServiceId: item.teamScheduleIdServideId,
                    serviceId: item.serviceId,
                    serviceName: item.serviceName,
                    type: item.teamType,
                    freelancerId: item.freelancerId,
                    freelancerName: item.freelancerName,
                    connectingId: item.connectingId
                }

                if (item.teamType === "InHouse") {
                    const inHouseProps = {
                        serviceLevelStatusId: item.serviceLevelStatusId,
                        fileCount: parseInt(item.fileCount),
                        size: item.size,
                        remarks: item.remarks
                    }

                    if (isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...commonProps }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...commonProps, remarks: item.remarks }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && !isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...commonProps, size: item.size }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && !isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...commonProps, size: item.size, remarks: item.remarks }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...commonProps, fileCount: parseInt(item.fileCount) }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...commonProps, fileCount: parseInt(item.fileCount), remarks: item.remarks }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...commonProps, serviceLevelStatusId: item.serviceLevelStatusId }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...commonProps, serviceLevelStatusId: item.serviceLevelStatusId, remarks: item.remarks }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...commonProps, serviceLevelStatusId: item.serviceLevelStatusId, fileCount: parseInt(item.fileCount) }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...commonProps, serviceLevelStatusId: item.serviceLevelStatusId, fileCount: parseInt(item.fileCount), remarks: item.remarks }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && !isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...commonProps, serviceLevelStatusId: item.serviceLevelStatusId, size: item.size }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && !isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...commonProps, serviceLevelStatusId: item.serviceLevelStatusId, size: item.size, remarks: item.remarks }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && !isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...commonProps, serviceLevelStatusId: item.serviceLevelStatusId, fileCount: parseInt(item.fileCount), size: item.size }
                    } else {
                        return { ...commonProps, ...inHouseProps }
                    }
                } else {
                    const freelancerProps = {
                        serviceLevelStatusId: item.serviceLevelStatusId,
                        fileCount: parseInt(item.fileCount),
                        size: item.size,
                        remarks: item.remarks
                    }

                    if (isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, remarks: item.remarks }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && !isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, size: item.size }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && !isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, size: item.size, remarks: item.remarks }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, fileCount: parseInt(item.fileCount) }
                    } else if (isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, fileCount: parseInt(item.fileCount), remarks: item.remarks }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, serviceLevelStatusId: item.serviceLevelStatusId }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, serviceLevelStatusId: item.serviceLevelStatusId, remarks: item.remarks }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, serviceLevelStatusId: item.serviceLevelStatusId, fileCount: parseInt(item.fileCount) }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, serviceLevelStatusId: item.serviceLevelStatusId, fileCount: parseInt(item.fileCount), remarks: item.remarks }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && !isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, serviceLevelStatusId: item.serviceLevelStatusId, size: item.size }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount == undefined && !isEmpty(item.size) && !isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, serviceLevelStatusId: item.serviceLevelStatusId, size: item.size, remarks: item.remarks }
                    } else if (!isEmpty(item.serviceLevelStatusId) && item.fileCount != undefined && !isEmpty(item.size) && isEmpty(item.remarks)) {
                        return { ...freelancerCommonProps, serviceLevelStatusId: item.serviceLevelStatusId, fileCount: parseInt(item.fileCount), size: item.size }
                    } else {
                        return { ...freelancerCommonProps, ...freelancerProps }
                    }
                }

            }) : []


        var dataScheduling = {
            "_id": data.dataCopyId,
            "leadId": id,
            "clientId": clientId,
            "teamScheduleId": data.teamScheduleId,
            "leadEventId": data.leadEventId,
            "eventId": data.event,
            "eventName": data.eventName,
            "eventDate": moment(data.eventDate).format("YYYY-MM-DD"),
            "serviceDetails": serviceDetails
        }

        console.log(dataScheduling, "dataScheduling")
        dispatch(copyDataAction.updateDataScheduling(dataScheduling))
        setEditModal(false)
        setTimeout(() => {
            // setOpen(false)
            toast.success("Records Updated Successfully", {
                position: toast.POSITION.TOP_RIGHT,
            })

            dispatch(copyDataAction.loadDataScheduling({ leadId: id }))
        }, 2000)
    }


    //nas link
    const serviceLevelStatusOptions = serviceLevel_details && !isEmpty(serviceLevel_details) ?
        serviceLevel_details.map((data) => {
            return {
                label: data.serviceLevelName,
                value: data._id
            }
        }) : []
    const handleHideMessages = () => {
        simpleUploadValidator.current.hideMessages()
        simpleValidator.current.hideMessages()
        setRenderPage(!renderPage)
    }
    //folderType
    const folderTypeOptions = [{ label: "PHOTO", value: "PHOTO" }, { label: "CANDID VIDEO", value: "CANDID VIDEO" },
    { label: "TRADITIONAL VIDEO", value: "TRADITIONAL VIDEO" }]

    const [nasData, setNasData] = useState([{
        folderType: "",
        folderTypeValue: "",
        statusId: "",
        statusName: "",
        fileCount: "",
        size: "",
        link: "",
        _id: "",
        leadId: "",
        clientId: "",
        remarks: ""
    }])
    const [isEditNas, setIsEditNas] = useState(false)
    const addNasDetails = () => {
        setNasData([
            ...nasData,
            {
                folderType: "",
                folderTypeValue: "",
                statusId: "",
                statusName: "",
                fileCount: "",
                size: "",
                link: "",
                _id: "",
                leadId: "",
                clientId: "",
                remarks: ""
            },
        ])
        setRenderPage(!renderPage)
    }
    const [nasLinkModal, setNasLinkModal] = useState(false)
    const nasChange = (e, index, name) => {
        const paymentdataList = [...nasData]
        if (

            name === "fileCount" ||
            name === "size" ||
            name === "link" ||
            name === "remarks"
        ) {
            paymentdataList[index][name] = e.target.value
        }
        if (name === "statusId") {
            paymentdataList[index]["statusId"] = e.value
            paymentdataList[index]["statusName"] = e.label

        }
        if (name === "folderTypeValue") {
            paymentdataList[index]["folderTypeValue"] = e.value
            paymentdataList[index]["folderType"] = e.label

        }
        setNasData(paymentdataList)
        setRenderPage(!renderPage)
    }
    const removeNasdetails = async (toRemove) => {
        var paymentList = nasData
        if (toRemove != 0) {
            if (toRemove > -1) {
                paymentList.splice(toRemove, 1)
            }
            setNasData(paymentList)
            setRenderPage(!renderPage)
        }
    }
    const handleNasModal = () => {
        setNasLinkModal(false)
    }
    //edit functionality
    const editNasLinkDetails = (item) => {
        setNasData([{

            folderType: item.folderType,
            folderTypeValue: item.folderType,
            statusId: !isEmpty(item.serviceLevelStatusId) && item.serviceLevelStatusId != null ?
                item.serviceLevelStatusId._id : "",
            statusName: !isEmpty(item.serviceLevelStatusId) && item.serviceLevelStatusId != null ?
                item.serviceLevelStatusId.serviceLevelName : "",
            fileCount: item.fileCount,
            size: item.size,
            link: item.link,
            _id: item._id,
            leadId: item.leadId,
            clientId: item.clientId,
            remarks: item.remarks
        }])
    }
    const clearNasLinkModal = () => {
        setNasData([{
            folderType: "",
            folderTypeValue: "",
            statusId: "",
            statusName: "",
            fileCount: "",
            size: "",
            link: "",
            _id: "",
            leadId: "",
            clientId: "",
            remarks: ""
        },
        ])
    }
    const [deleteNasmodal, setDeleteNasmodal] = useState(false)
    const [deleteDetails, setDeleteDetails] = useState("")

    const addNasLinkDetailsData =
        !isEmpty(nasData) && nasData.length > 0
            ? nasData.map((data) => {
                if (data) {
                    return {

                        "folderType": data.folderTypeValue,
                        "serviceLevelStatusId": data.statusId,
                        "fileCount": data.fileCount,
                        "size": data.size,
                        "link": data.link,
                        "remarks": data.remarks
                    }
                }
            })
            : []
    const deleteNasLink = () => {
        const deleteNasLinkData = {
            "naslinkId": deleteDetails._id,
            "leadId": deleteDetails.leadId,
            "status": 3
        }
        dispatch(copyDataAction.removeNasLink(deleteNasLinkData))
        setTimeout(() => {
            dispatch(copyDataAction.loadNasLinkList({ leadId: id }))
            toast.success("Nas Link Deleted successfully", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1000,
            })
        }, 1000)
    }

    const updateNasLink = () => {
        const formValid = simpleValidator.current.allValid()
        if (formValid) {
            const dataNas = nasData[0]
            const nasLinkDetailsData = {
                "_id": dataNas._id,
                "leadId": dataNas.leadId,
                "clientId": dataNas.clientId,
                "folderType": dataNas.folderTypeValue,
                "serviceLevelStatusId": dataNas.statusId,
                "fileCount": dataNas.fileCount,
                "size": dataNas.size,
                "link": dataNas.link,
                "remarks": dataNas.remarks
            }

            dispatch(copyDataAction.updateNasLink(nasLinkDetailsData))
            setTimeout(() => {
                dispatch(copyDataAction.loadNasLinkList({ leadId: id }))
                toast.success("Nas Link Updated successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1000,
                })
                setNasLinkModal(false)
                handleHideMessages()
            }, 1000)
        }
        else {
            simpleValidator.current.showMessages()
            setRenderPage(!renderPage)
            forceUpdate(1)
        }
    }
    const addNasLink = () => {
        const formValid = simpleValidator.current.allValid()
        if (formValid) {
            const addNasLinkData = {
                "leadId": id,
                "clientId": clientId,
                "nasLinkDetails": addNasLinkDetailsData
            }
            dispatch(copyDataAction.addNasLink(addNasLinkData))
            setTimeout(() => {
                dispatch(copyDataAction.loadNasLinkList({ leadId: id }))
                toast.success("Nas Link Updated successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1000,
                })
                setNasLinkModal(false)
                handleHideMessages()
            }, 1000)
        } else {
            simpleValidator.current.showMessages()
            setRenderPage(!renderPage)
            forceUpdate(1)
        }
    }
    const [updateModal, setUpdateModal] = useState(false)
    const [uploadQcData, setUploadQcData] = useState({
        description: ""
    })
    const handleQC = async (e) => {
        setUploadQcData({ ...uploadQcData, [e.target.name]: e.target.value })
    }

    const uploadCommit = () => {
        const formValid = simpleUploadValidator.current.allValid()
        if (formValid) {
            const nasCommitDetails = {
                leadId: id,
                remarks: uploadQcData.description

            }
            dispatch(copyDataAction.updateNasCommit(nasCommitDetails))
            setTimeout(() => {
                // dispatch(
                //   copyDataAction.loadDataCopy(searchValue)
                // )
                dispatch(clientAction.loadRecordClientProfileById({
                    mode: "Data",
                    clientId: clientId,
                }))
                toast.success("Approved successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1000,
                })
                handleHideMessages()
                setUpdateModal(false)
            }, 1000)
        } else {
            simpleUploadValidator.current.showMessages()
            setRenderPage(!renderPage)
            forceUpload(1)
        }
    }
    const [nasValidModal, setNasValidModal] = useState(false)
    const nasLinkValidUpdate = () => {
        if (!isEmpty(nas_link_details)) {
            setUpdateModal(true)
            handleHideMessages()
            setUploadQcData({
                description: ""
            })
            setNasValidModal(false)
        } else {
            setNasValidModal(true)
        }
    }
    return (
        <React.Fragment>
            <Container>
                <Row className="quote-head-content mb-4">
                    <Col lg="9" md="9" sm="12">
                        <div className="d-flex">
                            <p className="quote-head">
                                Nas Link
                                <span className="quote-info">
                                    <i
                                        style={{ color: "grey" }}
                                        id="quoteInfo12"
                                        aria-hidden="true"
                                        className="fa fa-info-circle ms-1"
                                    ></i>
                                    <UncontrolledTooltip placement="right" target="quoteInfo12">
                                        Nas Link
                                    </UncontrolledTooltip>
                                </span>
                            </p>
                            <Button className={!isEmpty(isNasCommit) ? "btn btn-success" : "btn btn-warning"}
                                onClick={() => nasLinkValidUpdate()}
                            >{!isEmpty(isNasCommit) ? isNasCommit : "Pending"}</Button>
                        </div>
                    </Col>
                    <Col lg="3" md="3" sm="12">
                        <Button
                            style={{
                                backgroundColor: "#4486eb",
                                border: "none",
                                marginTop: "20px",
                                float: "right",
                            }}
                            onClick={() => {
                                setNasLinkModal(true)
                                clearNasLinkModal()
                                setIsEditNas(false)
                                handleHideMessages()
                            }}
                        >
                            Add Nas Link
                        </Button>
                    </Col>
                    <Col md="12" lg="12" xl="12" className="mt-3">
                        <Table striped bordered>
                            <thead>
                                <tr style={{ fontSize: "10px" }}>
                                    {/* <th>S.No</th> */}
                                    <th style={{ width: "7%" }}>S.No</th>
                                    <th style={{ width: "8%" }}>Actions</th>
                                    <th style={{ width: "10%" }}>Folder Type</th>
                                    <th style={{ width: "20%" }}>Status</th>
                                    <th style={{ width: "10%" }}>File Count</th>
                                    <th style={{ width: "10%" }}>Size</th>
                                    <th style={{ width: "20%" }}>Link</th>
                                    <th style={{ width: "10%" }}>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                {nas_link_details && !isEmpty(nas_link_details) && nas_link_details.length > 0 ?
                                    nas_link_details.map((item, index) => {

                                        return (<tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{<div style={{ display: "flex" }}>
                                                <Button
                                                    type="submit"
                                                    onClick={() => {
                                                        setNasLinkModal(true)
                                                        editNasLinkDetails(item)
                                                        setIsEditNas(true)
                                                    }}
                                                    style={{ fontSize: "10px" }}
                                                    className="btn btn-success buttons btn-sm"
                                                >
                                                    <i
                                                        className="fas fa-pencil-alt icon-btn fa-sm"
                                                        style={{ fontSize: "13px" }}
                                                    ></i>
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    onClick={() => {
                                                        setDeleteDetails(item)
                                                        setDeleteNasmodal(true)

                                                    }}
                                                    style={{ fontSize: "10px", marginLeft: "20px" }}
                                                    className="btn btn-danger buttons btn-sm"
                                                >
                                                    <i
                                                        className="fas fa-trash-alt icon-btn fa-sm"
                                                        style={{ fontSize: "12px" }}
                                                    ></i>
                                                </Button>
                                            </div>}</td>
                                            <td>{item.folderType}</td>
                                            <td>{item.serviceLevelStatusId != null ? item.serviceLevelStatusId.serviceLevelName : ""}</td>
                                            <td>{item.fileCount}</td>
                                            <td>{item.size}</td>
                                            <td>{item.link}</td>
                                            <td>{item.remarks ? item.remarks : "--"}</td>
                                        </tr>
                                        )
                                    }) : (
                                        <tr key={0}>
                                            <td className="text-align-center" colSpan={8}>
                                                No data found
                                            </td>
                                        </tr>
                                    )}

                            </tbody></Table>
                    </Col>
                </Row>
                <Row className="quote-head-content mb-4">
                    <Col md="9" lg="9" sm="9" className="d-flex flex-row">
                        <p className="quote-head">
                            Data Copy
                            <span className="quote-info">
                                <i
                                    style={{ color: "grey" }}
                                    id="quoteInfo1"
                                    aria-hidden="true"
                                    className="fa fa-info-circle ms-1"
                                ></i>
                                <UncontrolledTooltip placement="right" target="quoteInfo1">
                                    Data Copy
                                </UncontrolledTooltip>
                            </span>
                        </p>
                        {/* <div style={{ width: "150px", marginRight: "10px" }}>
                            <MultiSelect
                                value={tableFilterOpt}
                                onChange={setTableFilterOpt}
                                options={finalCommitOptions}
                                labelledBy="Select Event"
                                hasSelectAll={true}
                                disabled={modeMenu === "EventComplete" ? true : false}
                            />
                            {finalCommitValidation && tableFilterOpt.length == 0 ? (
                                <span
                                    style={{
                                        fontSize: "10px",
                                        color: "red",
                                    }}
                                >
                                    Final Commit field is required
                                </span>
                            ) : (
                                ""
                            )}
                        </div>
                        <div>
                            <Button
                                type="submit"
                                className="btn btn-danger"
                                disabled={modeMenu === "EventComplete" ? true : false}
                                onClick={() => {
                                    if (tableFilterOpt.length > 0) {
                                        setFinalCommitModal(true)
                                    } else {
                                        setFinalCommitValidation(true)
                                    }
                                }}
                            >
                                Final Commit
                            </Button>
                        </div> */}
                    </Col>
                </Row>
                <div className="mb-4">
                    {!isEmpty(collapseData) && collapseData.length > 0
                        ? (collapseData.map((data, idx) => {


                            console.log(data, "id from service")
                            console.log(collapseDetails, "commiStatus")
                            return (
                                <Row
                                    className="question-card-content mb-1"
                                    style={{
                                        padding: "0px 4px",
                                    }}
                                    key={idx}
                                >
                                    <Col>
                                        <div className="d-flex flex-row ">
                                            <p
                                                style={{
                                                    fontSize: "15px",
                                                    marginBottom: "12px",
                                                    marginRight: "8px",
                                                    // padding: "0px 8px",
                                                    fontWeight: 550,
                                                    marginTop: "10px",
                                                }}
                                            >
                                                {data.eventNo}
                                                {/* Event */}
                                            </p>

                                            {!isEmpty(data.dataCopyId) ? (
                                                <div className="mx-3" style={{ marginTop: "10px" }}>
                                                    {editModal === true ? (
                                                        <Button
                                                            type="submit"
                                                            style={{ fontSize: "8px" }}
                                                            onClick={() => {
                                                                if (data.leadEventId) {
                                                                    setCollapseDetails(data)
                                                                    // editTeamEvents(data)
                                                                    setEditModal(false)
                                                                    // setLeadEventId("")
                                                                    // setServiceDetailsData("")
                                                                }
                                                                // if (data.leadEventId === commitStatus.leadEventId) {
                                                                // setEditTeamScheduleDetails(event_team_scheduling)
                                                                // }
                                                            }}
                                                            className={"btn btn-success"}
                                                        >
                                                            <i className="fas fa-edit icon-btn"></i>
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            type="submit"
                                                            style={{ fontSize: "8px" }}
                                                            onClick={() => {
                                                                if (data.leadEventId) {
                                                                    setCollapseDetails(data)
                                                                    editTeamEvents(data)
                                                                    setEditModal(true)
                                                                    setOpen(false)
                                                                    editDataCopyScheduling(data)
                                                                }
                                                            }}
                                                            className={"btn btn-success"}
                                                        >
                                                            <i className="fas fa-edit icon-btn"></i>
                                                        </Button>
                                                    )}
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                            {/* {!isEmpty(data) && data.isCommitted === true ? (
                                                <div
                                                    style={{
                                                        marginTop: "12.5px",
                                                    }}
                                                >
                                                    {" "}
                                                    <button
                                                        style={{
                                                            background: "#34c38f",
                                                            border: "none",
                                                            // cursor: "pointer",
                                                            fontSize: "12px",
                                                            color: "white",
                                                            padding: "2px 2px",
                                                            borderRadius: "4px",
                                                        }}
                                                    >
                                                        {"Committed"}
                                                    </button>
                                                </div>
                                            ) : (
                                                <div
                                                    style={{
                                                        marginTop: "12.5px",
                                                    }}
                                                >
                                                    <button
                                                        style={{
                                                            background: "#f34848",
                                                            border: "none",
                                                            // cursor: "pointer",
                                                            fontSize: "12px",
                                                            color: "white",
                                                            padding: "2px 2px",
                                                            borderRadius: "4px",
                                                        }}
                                                    >
                                                        {"Not Committed"}
                                                    </button>
                                                </div>
                                            )} */}
                                        </div>
                                    </Col>
                                    <Col>

                                        <div
                                            style={{
                                                color: "#291213",
                                                height: "22px",
                                                width: "max-content",
                                                textAlign: "center",
                                                cursor: "pointer",
                                                fontSize: "24px",
                                                marginTop: "10px",
                                                float: "right",
                                                display: "flex",
                                            }}
                                            className={
                                                !isEmpty(data.dataCopyId) ? "disabled-button" : ""
                                            }
                                            aria-controls="example-collapse-text"
                                            aria-expanded={open}
                                            onClick={() => {
                                                if (data.leadEventId) {
                                                    setCollapseDetails(data)
                                                    setCollapseServiceDetails(data)
                                                    setOpen(!open)
                                                    setLeadEventId(data.leadEventId)
                                                    setServiceOpen(true)
                                                     setEditModal(false)
                                                    editDataCopyScheduling(data)
                                                    //    clearServiceData()
                                                 //   editTeamEvents(data)
                                                    setPageLoad(!pageLoad)
                                                }
                                            }}
                                        >
                                            <i className="fas fa-angle-down"></i>
                                        </div>
                                        {/* )} */}
                                    </Col>
                                    <Collapse
                                        in={
                                            (data.leadEventId === collapseDetails.leadEventId &&
                                                open) ||
                                            (data.leadEventId === collapseDetails.leadEventId &&
                                                editModal)
                                        }
                                    >
                                        <div id="example-collapse-text">
                                            <Col>
                                                <Row>
                                                    <Col md="2" lg="2" sm="2" className="mt-3">
                                                        <Card
                                                            style={{
                                                                border: "2px solid rgb(239, 242, 247)",
                                                                textAlign: "center",
                                                                boxShadow:
                                                                    "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px",
                                                            }}
                                                        >
                                                            <CardBody>
                                                                <Col sm="12" md="12" lg="12">
                                                                    <div
                                                                        style={{
                                                                            fontSize: "22px",
                                                                            fontWeight: "bold",
                                                                            flex: "display",
                                                                        }}
                                                                    >
                                                                        {" "}
                                                                        EVENT
                                                                    </div>
                                                                </Col>

                                                                <h1
                                                                    style={{
                                                                        color: "#E40D8C",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    {!isEmpty(collapseDetails)
                                                                        ? collapseDetails.eventNo.split("Event")
                                                                        : ""}
                                                                </h1>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                    <Col md="10" lg="10" sm="10" className="mb-2">
                                                        <Row className="mt-2">
                                                            <Col md="3" lg="3" sm="3">
                                                                <p
                                                                    style={{
                                                                        fontWeight: "450",
                                                                        marginBottom: "-1px",
                                                                    }}
                                                                >
                                                                    {"Event Name :"}
                                                                </p>
                                                                <p style={{ fontWeight: "550" }}>
                                                                    {!isEmpty(collapseDetails.eventName) || open
                                                                        ? collapseDetails.eventName : "--"}
                                                                </p>
                                                            </Col>
                                                            <Col md="3" lg="3" sm="3">
                                                                <p
                                                                    style={{
                                                                        fontWeight: "450",
                                                                        marginBottom: "-1px",
                                                                    }}
                                                                >
                                                                    {"Date :"}
                                                                </p>
                                                                <p style={{ fontWeight: "550" }}>
                                                                    {!isEmpty(collapseDetails.eventDate) || open
                                                                        ? moment(collapseDetails.eventDate).format(
                                                                            "DD-MM-YYYY"
                                                                        ) : "--"}
                                                                </p>
                                                            </Col>
                                                            <Col md="3" lg="3" sm="3">
                                                                <p
                                                                    style={{
                                                                        fontWeight: "450",
                                                                        marginBottom: "-1px",
                                                                    }}
                                                                >
                                                                    {"Start Time :"}
                                                                </p>
                                                                <p style={{ fontWeight: "550" }}>
                                                                    {!isEmpty(collapseDetails.startTime) || open
                                                                        ? eventStartTimeData
                                                                        : "--"}
                                                                </p>
                                                            </Col>
                                                            <Col md="3" lg="3" sm="3">
                                                                <p
                                                                    style={{
                                                                        fontWeight: "450",
                                                                        marginBottom: "-1px",
                                                                    }}
                                                                >
                                                                    End Time:
                                                                </p>
                                                                <p style={{ fontWeight: "550" }}>
                                                                    {!isEmpty(collapseDetails.endTime) || open
                                                                        ? eventEndTimeData : "--"}
                                                                </p>
                                                            </Col>
                                                            <Col md="3" lg="3" sm="3">
                                                                <p
                                                                    style={{
                                                                        fontWeight: "450",
                                                                        marginBottom: "-1px",
                                                                    }}
                                                                >
                                                                    Venue Name :
                                                                </p>
                                                                <p
                                                                    style={{
                                                                        fontWeight: "550",
                                                                        // width: "max-content",
                                                                    }}
                                                                >
                                                                    {!isEmpty(collapseDetails.venueName) || open
                                                                        ? collapseDetails.venueName : "--"}
                                                                </p>
                                                            </Col>
                                                            <Col md="3" lg="3" sm="3">
                                                                <p
                                                                    style={{
                                                                        fontWeight: "450",
                                                                        marginBottom: "-1px",
                                                                    }}
                                                                >
                                                                    Venue Location:
                                                                </p>
                                                                <p style={{ fontWeight: "550" }}>
                                                                    {!isEmpty(collapseDetails.venueLocation) ||
                                                                        open
                                                                        ? collapseDetails.venueLocation : "--"}
                                                                </p>
                                                            </Col>
                                                            <Col md="3" lg="3" sm="3">
                                                                <p
                                                                    style={{
                                                                        fontWeight: "450",
                                                                        marginBottom: "-1px",
                                                                    }}
                                                                >
                                                                    Food :
                                                                </p>
                                                                <p style={{ fontWeight: "550" }}>
                                                                    {!isEmpty(collapseDetails.food) || open
                                                                        ? collapseDetails.food : "--"}
                                                                </p>
                                                            </Col>
                                                            <Col md="3" lg="3" sm="3">
                                                                <p
                                                                    style={{
                                                                        fontWeight: "450",
                                                                        marginBottom: "-1px",
                                                                    }}
                                                                >
                                                                    Travel :
                                                                </p>
                                                                <p style={{ fontWeight: "550" }}>
                                                                    {!isEmpty(collapseDetails.travelStay) || open
                                                                        ? collapseDetails.travelStay
                                                                        : "--"}
                                                                </p>
                                                            </Col>
                                                            <Col md="3" lg="3" sm="3">
                                                                <p
                                                                    style={{
                                                                        fontWeight: "450",
                                                                        marginBottom: "-1px",
                                                                    }}
                                                                >
                                                                    Crew Assembly :
                                                                </p>
                                                                <p style={{ fontWeight: "550" }}>
                                                                    {!isEmpty(collapseDetails.crewAssemblyTime) ||
                                                                        open
                                                                        ? crewAssemblyTimeData
                                                                        : "--"}
                                                                </p>
                                                            </Col>
                                                            <Col md="3" lg="3" sm="3">
                                                                <p
                                                                    style={{
                                                                        fontWeight: "450",
                                                                        marginBottom: "-1px",
                                                                    }}
                                                                >
                                                                    Crowd Strength :
                                                                </p>
                                                                <p style={{ fontWeight: "550" }}>
                                                                    {collapseDetails.crowdStrength ||
                                                                        open
                                                                        ? collapseDetails.crowdStrength : "--"}
                                                                </p>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col>
                                                <Row className="mt-3 mb-2">
                                                    <Col sm="12" md="12" lg="12">
                                                        <div className="d-flex flex-row justify-content-end">
                                                            {/* <Button
                                className={"btn btn-success"}
                                style={{ marginRight: "6px" }}
                                onClick={() => {
                                  setEditTeamModal(true)
                                  setTeamServiceEventId(data.leadEventId)
                                }}
                              >
                                {"Edit"}
                              </Button> */}
                                                            {/* <Button
                                                                className={
                                                                    !isEmpty(data) && data.isCommitted === true
                                                                        ? "btn btn-success"
                                                                        : "btn btn-danger"
                                                                }
                                                                style={{ marginRight: "6px" }}
                                                                onClick={() => {
                                                                    // if (
                                                                    //   data.leadEventId ===
                                                                    //   collapseDetails.leadEventId
                                                                    // ) {
                                                                    setEventCommit(true)
                                                                    //setEventId(data.leadEventId)
                                                                    // }
                                                                }}
                                                                disabled={
                                                                    modeMenu === "EventComplete" ? true : false
                                                                }
                                                            >
                                                                {!isEmpty(data) && data.isCommitted === true
                                                                    ? "Committed"
                                                                    : "Final Commit"}
                                                            </Button> */}
                                                            {/* <div
                                                                style={{
                                                                    marginLeft: "-13px",
                                                                    marginTop: "-8px",
                                                                    marginRight: "6px",
                                                                }}
                                                            >
                                                                <p
                                                                    style={{
                                                                        color: "#fffff",
                                                                        fontSize: "12px",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    className={"badge bg-warning rounded-pill"}
                                                                    onClick={() => setCommitHistoryModal(true)}
                                                                >
                                                                    {!isEmpty(commitHistoryDetails)
                                                                        ? commitHistoryDetails.length
                                                                        : 0}
                                                                </p>
                                                            </div> */}


                                                        </div>
                                                    </Col>
                                                </Row>



                                                <Row className="h-100 mb-5">
                                                    <Col md="12" lg="12" xl="12">
                                                        <Table striped bordered>
                                                            <thead>
                                                                <tr style={{ fontSize: "10px" }}>
                                                                    {/* <th>S.No</th> */}
                                                                    <th style={{ width: "15%" }}>Service Name</th>
                                                                    <th style={{ width: "10%" }}>Type</th>
                                                                    <th style={{ width: "15%" }}>Shooter Name</th>
                                                                    <th style={{ width: "15%" }}>Status</th>
                                                                    <th style={{ width: "15%" }}>File Count</th>
                                                                    <th style={{ width: "15%" }}>Size</th>
                                                                    <th style={{ width: "15%" }}>Remarks</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {!isEmpty(serviceDetailsData) ? (
                                                                    serviceDetailsData.map((service, index) => {
                                                                        //Sub freelancer dropdown
                                                                        console.log(index, "index")
                                                                        const shooterName = service && service.teamType == "InHouse" ?
                                                                            service.teamEmployeeShooterName : service.freelancerName
                                                                        return (
                                                                            <tr
                                                                                key={index}
                                                                                style={{
                                                                                    background:
                                                                                        data.isAlter == true
                                                                                            ? "#fd8301b3"
                                                                                            : "",
                                                                                    color:
                                                                                        data.isAlter == true ? "white" : "",
                                                                                }}
                                                                            >
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    {service.serviceName}
                                                                                </td>

                                                                                <td>{service.teamType}</td>
                                                                                <td>{shooterName}</td>
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    <Select
                                                                                        name="serviceLevelStatusId"
                                                                                        value={
                                                                                            service.serviceLevelStatusId
                                                                                                ? {
                                                                                                    value: service.serviceLevelStatusId,
                                                                                                    label: service.serviceLevelStatusName,
                                                                                                }
                                                                                                : { value: "", label: "Select" }
                                                                                        }
                                                                                        options={serviceLevelStatusOptions}

                                                                                        onChange={(e) =>
                                                                                            modalChange(e, index, "serviceLevelStatusId")
                                                                                        }
                                                                                        placeholder="Select Status"
                                                                                        classNamePrefix="select2-selection"
                                                                                    />
                                                                                </td>
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    <Input
                                                                                        type="text"
                                                                                        name="fileCount"
                                                                                        value={service.fileCount}
                                                                                        onChange={(e) =>
                                                                                            modalChange(e, index, "fileCount")
                                                                                        }
                                                                                        placeholder="Enter File Count"
                                                                                    />

                                                                                </td>
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    <Input
                                                                                        type="text"
                                                                                        name="size"
                                                                                        value={service.size}
                                                                                        onChange={(e) =>
                                                                                            modalChange(e, index, "size")
                                                                                        }
                                                                                        placeholder="Enter Size"
                                                                                    />

                                                                                </td>
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    <Input
                                                                                        type="text"
                                                                                        name="remarks"
                                                                                        value={service.remarks}
                                                                                        onChange={(e) =>
                                                                                            modalChange(e, index, "remarks")
                                                                                        }
                                                                                        placeholder="Enter remarks"
                                                                                    />

                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                ) : (
                                                                    <tr key={0}>
                                                                        <td
                                                                            colSpan={8}
                                                                            className="text-align-center"
                                                                        >
                                                                            No Records Found..
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col>
                                                <div style={{ float: "right" }}>
                                                    {eventServiceModal && open === false ? (
                                                        <>
                                                            <Button
                                                                className={
                                                                    modeMenu === "EventComplete"
                                                                        ? "disabled-button btn btn-success mb-2"
                                                                        : "btn btn-success mb-2"
                                                                }
                                                                onClick={() => updateTeamEvents(data)}
                                                            >
                                                                Update
                                                            </Button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Button
                                                                type="submit"
                                                                className={
                                                                    modeMenu === "EventComplete"
                                                                        ? "disabled-button btn btn-success mb-2"
                                                                        : "btn btn-success mb-2"
                                                                }
                                                                onClick={() => addTeamEvents(data)}
                                                            >
                                                                Submit
                                                            </Button>
                                                        </>
                                                    )}
                                                </div>
                                            </Col>
                                        </div>
                                    </Collapse>
                                </Row>
                            )
                        })
                        ) : (
                            <Row className="question-card-content" key={0}>
                                <Col>
                                    <p
                                        style={{
                                            fontSize: "15px",
                                            marginBottom: "-12px",
                                            fontWeight: 550,
                                            marginTop: "-1px",
                                        }}
                                    >
                                        {"No Events"}
                                    </p>
                                </Col>
                                <Col>
                                    <div
                                        style={{
                                            color: "#291213",
                                            height: "22px",
                                            width: "max-content",
                                            textAlign: "center",
                                            cursor: "pointer",
                                            fontSize: "24px",
                                            float: "right",
                                            display: "flex",
                                        }}
                                        aria-controls="example-collapse-text"
                                        aria-expanded={open}
                                        onClick={() => {
                                            setOpen(!open)
                                        }}
                                    >
                                        <i className="fas fa-angle-down"></i>
                                    </div>
                                </Col>
                            </Row>
                        )}
                </div>
                {finalCommitModal && (
                    <Modal
                        // show={finalCommitModal}
                        //  onHide={handleFinalCommitModal}
                        size="md"
                    // fullscreen={fullscreen}
                    >
                        <Modal.Header
                            style={{
                                backgroundColor: "#E40D8C",
                                color: "white",
                                fontSize: "16px",
                                fontWeight: "600",
                            }}
                        >
                            Confirm
                        </Modal.Header>
                        <Modal.Body>Do you want to commit the Event ?</Modal.Body>
                        <Modal.Footer>
                            <Button
                                className="btn btn-danger"
                                onClick={() => setFinalCommitModal(false)}
                            >
                                Close
                            </Button>
                            <Button
                                type="button"
                                className="btn btn-success"
                            //  onClick={() => finalCommit()}
                            >
                                Commit
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
                {eventCommit && (
                    <Modal
                        show={eventCommit}
                        //  onHide={handleEventCommitModal}
                        size="md"
                    // fullscreen={fullscreen}
                    >
                        <Modal.Header
                            style={{
                                backgroundColor: "#E40D8C",
                                color: "white",
                                fontSize: "16px",
                                fontWeight: "600",
                            }}
                        >
                            Confirm
                        </Modal.Header>
                        <Modal.Body>Do you want to commit the Event ?</Modal.Body>
                        <Modal.Footer>
                            <Button
                                className="btn btn-danger"
                                onClick={() => setEventCommit(false)}
                            >
                                Close
                            </Button>
                            <Button
                                className="btn btn-success"
                            // onClick={() => eventFinalCommit()}
                            >
                                Commit
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}

                {historyModal && (
                    <Modal
                        show={historyModal}
                        onHide={handleHistoryModal}
                        size="lg"
                    // fullscreen={fullscreen}
                    >
                        <Modal.Header
                            style={{
                                backgroundColor: "#E40D8C",
                                color: "white",
                                fontSize: "16px",
                                fontWeight: "600",
                            }}
                        >
                            Service History
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col sm="12" md="12" lg="12">
                                    <Table responsive striped>
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Lead No</th>
                                                <th>Event Date</th>
                                                <th>Event Name</th>
                                                <th>Event No</th>
                                                <th>Start Time</th>
                                                <th>End Time</th>
                                                <th>Venue Location</th>
                                                <th>Venue Name</th>
                                                <th>Service Name</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!isEmpty(shooter_history) &&
                                                shooter_history.length > 0 ? (
                                                shooter_history.map((history, index) => {
                                                    return (
                                                        <tr key={history._id}>
                                                            <th>{index + 1}</th>
                                                            <td>{history.leadNo}</td>
                                                            <td>
                                                                {moment(history.eventDate).format("DD-MM-YYYY")}
                                                            </td>
                                                            <td>{history.eventName}</td>
                                                            <td>{history.eventNo}</td>
                                                            <td>{history.startTime}</td>
                                                            <td>{history.endTime}</td>
                                                            <td>{history.eventLocation}</td>
                                                            <td>{history.venueName}</td>
                                                            <td>{history.serviceName}</td>
                                                        </tr>
                                                    )
                                                })
                                            ) : (
                                                <tr key={0}>
                                                    <td colSpan={10} style={{ textAlign: "center" }}>
                                                        No records found..
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                className="btn btn-danger"
                                onClick={() => setHistoryModal(false)}
                            >
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
                {commitHistoryModal && (
                    <Modal
                        show={commitHistoryModal}
                        onHide={handleCommitHistoryModal}
                        size="lg"
                    // fullscreen={fullscreen}
                    >
                        <Modal.Header
                            style={{
                                backgroundColor: "#E40D8C",
                                color: "white",
                                fontSize: "16px",
                                fontWeight: "600",
                            }}
                        >
                            Commit History
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col sm="12" md="12" lg="12">
                                    <Table responsive striped>
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Committed Date</th>
                                                <th>Committed By</th>
                                            </tr>
                                        </thead>
                                        {/* <tbody>
                                            {!isEmpty(commitHistoryDetails) &&
                                                commitHistoryDetails &&
                                                commitHistoryDetails.length > 0 ? (
                                                commitHistoryDetails.map((history, index) => {
                                                    return (
                                                        <tr key={history._id}>
                                                            <th>{index + 1}</th>
                                                            <td>
                                                                {moment(history.iscommitedOn).format(
                                                                    "DD-MM-YYYY"
                                                                )}
                                                            </td>
                                                            <td>{history.isCommitedBy.name}</td>
                                                        </tr>
                                                    )
                                                })
                                            ) : (
                                                <tr key={0}>
                                                    <td colSpan={10} style={{ textAlign: "center" }}>
                                                        No records found..
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody> */}
                                    </Table>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                className="btn btn-danger"
                                onClick={() => setCommitHistoryModal(false)}
                            >
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
                {nasLinkModal && (
                    <Modal
                        show={nasLinkModal}
                        onHide={handleNasModal}
                        size="lg"

                    >
                        <Modal.Header
                            style={{
                                backgroundColor: "#E40D8C",
                                color: "white",
                                fontSize: "16px",
                                fontWeight: "600",
                            }}
                        >
                            Add Nas Link
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col lg="12" md="12" sm="12">
                                    {isEditNas == false ? (<Button
                                        style={{
                                            backgroundColor: "#4486eb",
                                            border: "none",
                                            marginTop: "20px",
                                            float: "right",
                                        }}
                                        onClick={() => {
                                            addNasDetails()
                                        }}
                                    >
                                        Add More
                                    </Button>) : ""}
                                </Col>
                                <Col sm="12" md="12" lg="12" className="mt-2">
                                    <Table striped bordered>
                                        <thead>
                                            <tr style={{ fontSize: "10px" }}>
                                                <th style={{ width: "15%" }}>Folder Type</th>
                                                <th style={{ width: "20%" }}>Status</th>
                                                <th style={{ width: "15%" }}>File Count</th>
                                                <th style={{ width: "15%" }}>Size</th>
                                                <th style={{ width: "20%" }}>Link</th>
                                                <th style={{ width: "15%" }}>Remarks</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {nasData &&
                                                nasData.length > 0 &&
                                                nasData.map((data, index) => {
                                                    return (
                                                        <>
                                                            <tr className="bg-white" key={index}>
                                                                <td style={{ width: "15%" }}>
                                                                    {" "}
                                                                    <Select
                                                                        type="text"
                                                                        name="folderTypeValue"
                                                                        value={
                                                                            data.folderTypeValue
                                                                                ? {
                                                                                    value: data.folderTypeValue,
                                                                                    label: data.folderType,
                                                                                }
                                                                                : { value: "", label: "Select" }
                                                                        }
                                                                        onChange={(e) =>
                                                                            nasChange(e, index, "folderTypeValue")
                                                                        }
                                                                        placeholder="Enter"
                                                                        classNamePrefix="select2-selection"
                                                                        options={folderTypeOptions}
                                                                    />
                                                                    <div style={{ textTransform: "capitalize" }}>
                                                                        {simpleValidator.current.message(
                                                                            "FolderType",
                                                                            data.folderTypeValue,
                                                                            "required"
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td style={{ width: "20%" }}>
                                                                    <Select
                                                                        type="text"
                                                                        name="statusId"
                                                                        value={
                                                                            data.statusId
                                                                                ? {
                                                                                    value: data.statusId,
                                                                                    label: data.statusName,
                                                                                }
                                                                                : { value: "", label: "Select" }
                                                                        }
                                                                        onChange={(e) =>
                                                                            nasChange(e, index, "statusId")
                                                                        }
                                                                        placeholder="Enter"
                                                                        classNamePrefix="select2-selection"
                                                                        options={serviceLevelStatusOptions}
                                                                    />
                                                                    <div style={{ textTransform: "capitalize" }}>
                                                                        {simpleValidator.current.message(
                                                                            "Status",
                                                                            data.statusId,
                                                                            "required"
                                                                        )}
                                                                    </div>
                                                                </td>

                                                                <td style={{ width: "15%" }}>
                                                                    {" "}
                                                                    <Input
                                                                        type="text"
                                                                        name="fileCount"
                                                                        value={data.fileCount}
                                                                        onChange={(e) =>
                                                                            nasChange(
                                                                                e,
                                                                                index,
                                                                                "fileCount"
                                                                            )
                                                                        }
                                                                        placeholder="Enter File Count"
                                                                    />
                                                                </td>
                                                                <td style={{ width: "15%" }}>
                                                                    {" "}
                                                                    <Input
                                                                        type="text"
                                                                        name="size"
                                                                        value={data.size}
                                                                        onChange={(e) =>
                                                                            nasChange(e, index, "size")
                                                                        }
                                                                        placeholder="Enter Size"
                                                                    />
                                                                </td>
                                                                <td style={{ width: "20%" }}>
                                                                    {" "}
                                                                    <Input
                                                                        type="text"
                                                                        name="link"
                                                                        value={data.link}
                                                                        onChange={(e) =>
                                                                            nasChange(e, index, "link")
                                                                        }
                                                                        placeholder="Enter Link"
                                                                    />
                                                                    <div style={{ textTransform: "capitalize" }}>
                                                                        {simpleValidator.current.message(
                                                                            "Link",
                                                                            data.link,
                                                                            "required"
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td style={{ width: "20%" }}>
                                                                    {" "}
                                                                    <Input
                                                                        type="text"
                                                                        name="remarks"
                                                                        value={data.remarks}
                                                                        onChange={(e) =>
                                                                            nasChange(e, index, "remarks")
                                                                        }
                                                                        placeholder="Enter Remarks"
                                                                    />

                                                                </td>
                                                                {isEditNas == false ? (<td>
                                                                    {" "}
                                                                    <i
                                                                        className="fa fa-times remove-icon"
                                                                        onClick={() =>
                                                                            removeNasdetails(index)
                                                                        }
                                                                    ></i>{" "}
                                                                </td>) : ""}
                                                            </tr>
                                                        </>
                                                    )
                                                })}
                                        </tbody>

                                    </Table>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                className="btn btn-danger"
                                onClick={() => setNasLinkModal(false)}
                            >
                                Cancel
                            </Button>
                            {isEditNas ? (
                                <Button
                                    className="btn btn-success"
                                    onClick={() => {

                                        updateNasLink()
                                    }}
                                >
                                    Update
                                </Button>
                            ) : (<Button
                                className="btn btn-success"
                                onClick={() => {

                                    addNasLink()
                                }}
                            >
                                Submit
                            </Button>)}
                        </Modal.Footer>
                    </Modal>
                )}
                {deleteNasmodal && (
                    <Modal show={deleteNasmodal} size="md">
                        <Modal.Header
                            style={{
                                backgroundColor: "#E40D8C",
                                color: "white",
                                minHeight: "65px",
                                fontSize: "16px",
                                fontWeight: "600",
                            }}
                        >
                            {"Delete Nas Link"}
                        </Modal.Header>
                        <Modal.Body>Do you want To Delete the Nas Link?</Modal.Body>
                        <Modal.Footer>
                            <div>
                                <Button
                                    type="submit"
                                    onClick={() => {
                                        deleteNasLink()
                                        setTimeout(() => {
                                            setDeleteNasmodal(false)
                                        }, 500)
                                    }}
                                    style={{ fontSize: "10px", marginLeft: "20px" }}
                                    className="btn btn-success buttons"
                                >
                                    {" "}
                                    Yes
                                </Button>
                                <Button
                                    type="submit"
                                    onClick={() => {
                                        setDeleteNasmodal(false)
                                    }}
                                    style={{ fontSize: "10px", marginLeft: "20px" }}
                                    className="btn btn-danger buttons"
                                >
                                    {" "}
                                    No
                                </Button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                )}
                {updateModal && (
                    <Modal show={updateModal} size="md">
                        <Modal.Header
                            style={{
                                backgroundColor: "#E40D8C",
                                color: "white",
                                minHeight: "65px",
                                fontSize: "16px",
                                fontWeight: "600",
                            }}
                        >
                            <div className="d-flex flex-row">
                                <span>Update Nas Link</span>
                            </div>

                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col sm="12" md="12" xl="12" lg="12">
                                    <div className="d-flex justify-content-between">
                                        <Label
                                            className="form-label"
                                            htmlFor={"Event To Date"}
                                        >
                                            {"Description"} <span className="required ms-1">*</span>
                                        </Label>
                                    </div>
                                    <Input
                                        type="textarea"
                                        placeholder="Enter Description"
                                        name="description"
                                        value={uploadQcData.description}
                                        onChange={(e) => handleQC(e)}
                                    />
                                    <div style={{ textTransform: "capitalize" }}>
                                        {simpleUploadValidator.current.message(
                                            "Description",
                                            uploadQcData.description,
                                            "required"
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <div>
                                <Button
                                    // type="submit"
                                    onClick={() => {
                                        setUpdateModal(false)
                                    }}
                                    className="btn btn-danger buttons"
                                >
                                    {" "}
                                    Cancel
                                </Button>
                                <Button
                                    style={{ marginLeft: "10px" }}
                                    onClick={() => {

                                        uploadCommit()
                                    }}
                                    className="btn btn-success buttons"
                                >
                                    {" "}
                                    Submit
                                </Button>

                            </div>
                        </Modal.Footer>
                    </Modal>
                )}
                {nasValidModal && (
                    <Modal show={nasValidModal} size="md">
                        <Modal.Header
                            style={{
                                backgroundColor: "#E40D8C",
                                color: "white",
                                minHeight: "65px",
                                fontSize: "16px",
                                fontWeight: "600",
                            }}
                        >
                            <div className="d-flex flex-row">
                                <span>Error</span>
                            </div>

                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col sm="12" md="12" xl="12" lg="12">
                                    Please Add Nas Link
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <div>
                                <Button
                                    // type="submit"
                                    onClick={() => {
                                        setNasValidModal(false)
                                    }}
                                    className="btn btn-danger buttons"
                                >
                                    {" "}
                                    Cancel
                                </Button>


                            </div>
                        </Modal.Footer>
                    </Modal>
                )}
            </Container>
        </React.Fragment>
    )
}

CopyDataTeamScheduling.propTypes = {
    dispatch: PropTypes.func,
    clientProfile: PropTypes.any,
    modeMenu: PropTypes.any,
    clientId: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}

const mapStateToProps = () => ({
    //mapstate to props
})
//CopyDataTeamScheduling
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CopyDataTeamScheduling)
)
